export enum SessionStorageKey {
  USER_PERFORMANCE_TAB = 'USER_PERFORMANCE_TAB',
}
